import { createAssetManagementClient } from '@/shared/api/client'
import { z } from 'zod'
import { validateResponseIsOk } from '@/shared/api/validation'
import { createAssetSchema } from '@/features/assets/schemas'

const client = createAssetManagementClient()

export const createAsset = (values: z.infer<typeof createAssetSchema>) =>
  validateResponseIsOk(
    client.sendPost('v2/assets', { data: createAssetSchema.parse(values) })
  )
